import { useTranslation } from 'react-i18next';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsDynamicPricingTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.dynamic-pricing')} />
      <IntegrationsTable category={IntegrationCategory.DYNAMIC_PRICING} />
    </section>
  );
};

export default IntegrationsDynamicPricingTab;
